import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
//import { Col } from 'react-bootstrap/Form'
import { Form, Card, Button, Col, Jumbotron, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Menu from '../menu'
import errores from '../../middleware/errordb'
import back from '../../back.svg';
import config from '../../config';
//import funciones from '../../middleware/funciones';
import Mensajes from '../subcomponent/mensajes';
import ModalConfirm from '../subcomponent/modalConfirm';
import Factorprecio from '../subcomponent/factorprecio';

class Formularioservicios extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            titulo: "Crear Items",
            msg: 0,
            comp: "",
            id_items: "",
            empresa: currentCompany,
            descripcion: "",
            codigo_item: "",
            referencia: "",
            iva_item: "",
            retefuente_item: "",
            linea_item: "",
            grupo_item: "",
            tipo_item: "",
            centro_costo: "",
            tipo: currentUserType,
            mostrarMensaje: false,
            impuesto: [],
            retencion: [],
            lineas: [],
            grupos: [],
            tipos: [],
            mensaje: "",
            unidades: [],
            descripcion_corta: "",
            listasPrecios: [],
            precios: [],
            newpriceunit: []
        }
    }

    componentDidMount() {
        this.initItem()
    }

    initItem = (tmpId) => {
        const search = (tmpId || this.props.location.search).toString();
        let titulo = "";
        let id_items = "";
        const categoriaEdicion = search.replace('?', '');
        if (categoriaEdicion) {
            titulo = "Modificar Items";
            id_items = categoriaEdicion;

        } else {
            titulo = "Crear Items";
            id_items = "0";
        }
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/items/' + id_items, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datos = data.data;
                    const item = datos[0];
                    const impuesto = datos[1];
                    const retencion = datos[2];
                    const lineas = datos[3];
                    const unidades = datos[4];
                    const ultimo_codigo = datos[5][0];
                    const grupos = datos[6];
                    const tipos = datos[7];
                    const listasPrecios = datos[8];
                    const precios = datos[9];
                    this.setState({
                        //descripcion: datos[0]["CODIGO_EMPRESA"],
                        descripcion: (id_items === "0") ? "" : item[0]["DESCRIPCION_ITEM"],
                        codigo_item: (id_items === "0") ? ultimo_codigo["LAST_COD"] : item[0]["CODIGO_ITEM"],
                        referencia: (id_items === "0") ? "" : item[0]["REFERENCIA_ITEM"],
                        iva_item: (id_items === "0") ? "" : item[0]["IVA_ITEM"],
                        retefuente_item: (id_items === "0") ? "" : item[0]["RETEFUENTE_ITEM"],
                        linea_item: (id_items === "0") ? "" : item[0]["LINEA_ITEM"],
                        grupo_item: (id_items === "0") ? "" : item[0]["GRUPO_ITEM"],
                        tipo_item: (id_items === "0") ? "" : item[0]["TIPO_ITEM"],
                        centro_costo: (id_items === "0" || !item[0]["CENTRO_COSTO"]) ? "" : item[0]["CENTRO_COSTO"],
                        descripcion_corta: (id_items === "0") ? "" : item[0]["DESCRIPCION_CORTA_ITEM"],
                        unidades,
                        impuesto,
                        retencion,
                        lineas,
                        grupos,
                        tipos,
                        listasPrecios,
                        precios
                    });
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: data.message })
                }
            });
        this.setState({ id_items, titulo });

        fetch(config.servBackEnd + '/prices/listprices', datasend)
            .then(res => res.json())
            .then((data1) => {
                const precios = data1.data;
                this.setState({
                    precios
                })
            })
            .catch((error) => console.error(error))
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({ show: false });
        const { empresa } = this.state
        const { descripcion } = this.state
        const { codigo_item } = this.state
        const { referencia } = this.state
        const { iva_item } = this.state
        const { retefuente_item } = this.state
        const { linea_item } = this.state
        const { grupo_item } = this.state
        const { tipo_item } = this.state
        const { descripcion_corta } = this.state
        const { unidades, centro_costo } = this.state;

        let ruta = "";
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                empresa,
                descripcion,
                codigo_item,
                referencia,
                iva_item,
                retefuente_item,
                linea_item,
                grupo_item,
                tipo_item,
                descripcion_corta,
                unidades,
                centro_costo,
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
            }
        }

        if (this.state.id_items === "0") {
            ruta = config.servBackEnd + '/items/create';
        } else {
            ruta = config.servBackEnd + '/items/modify/' + this.state.id_items;
        }
        fetch(ruta, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const nuevoImpuesto = (data.data.insertId !== 0) ? data.data.insertId : this.state.id_items;
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", id_items: nuevoImpuesto })
                    const { newpriceunit } = this.state;
                    const datasend = {
                        method: 'POST',
                        body: JSON.stringify(newpriceunit),
                        headers: {
                            'Content-Type': 'application/json',
                            'tipo': this.state.tipo,
                            'empresa': empresa
                        }
                    };

                    fetch(config.servBackEnd + '/prices/savepriceunit/', datasend)
                        .then(response => response.json())
                        .then(data => {
                            //console.log(data);
                        })
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Items con errores:" + errores[data.code] + " " + data.message })
                }
            });
        event.preventDefault();
    }

    handleClose = () => {
        this.setState({ show: false });
    };

    aceptarCambios = (uni) => {
        const { newpriceunit } = this.state;
        let position = -1;
        newpriceunit.forEach((element, i) => {
            //console.log(element[0].ID_LISTA_PRECIOS, uni[0].ID_LISTA_PRECIOS);    
            if (element[0].ID_LISTA_PRECIOS === uni[0].ID_LISTA_PRECIOS) {
                position = i;
            }
        });

        if (position === -1) {
            newpriceunit.push(uni);
        } else {
            newpriceunit.splice(position, 1, uni)
        }

        this.setState({ newpriceunit });
    }

    render() {
        const mensajeBoton = (this.state.id_items === "0") ? 'Crear Item' : 'Modificar Item';
        const mensajeConfirm = (this.state.id_items === "0") ? '¿Esta seguro que desea crear el item?' : '¿Esta seguro que desea modificar el item?';
        const validacionUser = (this.state.tipo === '0' || this.state.tipo === '1');
        const { impuesto } = this.state;
        const { retencion } = this.state;
        const { lineas } = this.state;
        const { grupos } = this.state;
        const { tipos } = this.state;
        const { precios } = this.state;
        const { tipo_item } = this.state;
        const { grupo_item } = this.state;
        const { linea_item } = this.state;
        const { listasPrecios } = this.state;
        return (
            <div className="Formularioservicios">
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>{this.state.titulo}</h2>
                </Jumbotron>
                {!validacionUser && <p>Usuario no valido para este modulo</p>}
                {validacionUser &&
                    <div>
                        <OverlayTrigger placement='top-start' overlay={<Tooltip>Volver a Items!</Tooltip>}>
                            <div className="div-back">
                                <a href="/servicios/">
                                    <img src={back} className="icon" alt="" />
                                </a>
                            </div>
                        </OverlayTrigger>

                        <Card className="card">
                            <Card.Body>
                                <Form className="form" onSubmit={this.handleSubmit}>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Empresa</Form.Label>
                                            <Form.Control type="text" placeholder="Empresa" onChange={e => this.setState({ empresa: e.target.value })} value={this.state.empresa} required disabled />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Referencia</Form.Label>
                                            <Form.Control type="text" maxLength="20" placeholder="codigo" onChange={e => this.setState({ referencia: e.target.value.toUpperCase() })} value={this.state.referencia} required />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Codigo</Form.Label>
                                            <Form.Control type="text" maxLength="10" placeholder="codigo" onChange={e => this.setState({ codigo_item: e.target.value })} value={this.state.codigo_item} required disabled />
                                        </Form.Group>
                                        {/* 
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Porcentaje Iva</Form.Label>
                                            <Form.Control type="text" placeholder="codigo" onChange={e => this.setState({ iva_item: e.target.value })} value={this.state.iva_item} required />
                                        </Form.Group> */}
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Descripcion Factura Electronica</Form.Label>
                                            <Form.Control type="text" placeholder="Descripcion" onChange={e => this.setState({ descripcion: e.target.value.toUpperCase(), descripcion_corta: e.target.value.toUpperCase().substring(0, 32) })} value={this.state.descripcion} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Descripcion Factura Pos</Form.Label>
                                            <Form.Control type="text" maxLength="32" placeholder="Descripcion" onChange={e => this.setState({ descripcion_corta: e.target.value.toUpperCase() })} value={this.state.descripcion_corta} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Centro Costos</Form.Label>
                                            <Form.Control type="text" maxLength="4" placeholder="centro de costo" onChange={e => this.setState({ centro_costo: e.target.value.toUpperCase() })} value={this.state.centro_costo} />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Tipos</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ tipo_item: e.target.value, linea_item: "" })} value={this.state.tipo_item} required >
                                                <option value="">Seleccione</option>
                                                {tipos.map(function (currentData, index) {
                                                    return <option key={'t' + index} value={currentData.ID_TIPO_INVENTARIO}>{currentData.DESCRIPCION_TIPO_INV}</option>;
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Grupos</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ grupo_item: e.target.value, linea_item: "" })} value={this.state.grupo_item} required >
                                                <option value="">Seleccione</option>
                                                {grupos.map(function (currentData, index) {
                                                    if ((currentData.ID_TIPO_INVENTARIO || "").toString() === tipo_item.toString()) {
                                                        return <option key={'g' + index} value={currentData.ID_GRUPO_INVENTARIO}>{currentData.DESCRIPCION_GRUPO_INV}</option>;
                                                    } else {
                                                        return null;
                                                    }
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Linea</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ linea_item: e.target.value })} value={this.state.linea_item} required >
                                                <option value="">Seleccione</option>
                                                {lineas.map(function (currentData, index) {
                                                    if ((currentData.ID_GRUPO_INVENTARIO || "").toString() === grupo_item.toString() || currentData.ID_LINEA_INVENTARIO.toString() === linea_item.toString()) {
                                                        return <option key={'c' + index} value={currentData.ID_LINEA_INVENTARIO}>{currentData.DESCRIPCION_LINEA_INV}</option>;
                                                    } else {
                                                        return null
                                                    }
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Porcentaje Iva</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ iva_item: e.target.value })} value={this.state.iva_item} required >
                                                <option value="">Seleccione</option>
                                                {impuesto.map(function (currentData, index) {
                                                    return <option key={'i' + index} value={currentData.ID_IMPUESTOS}>{currentData.DESCRIPCION_IMPUESTO}</option>;
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Retefuente</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ retefuente_item: e.target.value })} value={this.state.retefuente_item} required >
                                                <option value="">Seleccione</option>
                                                {retencion.map(function (currentData, index) {
                                                    return <option key={'r' + index} value={currentData.ID_RETENCIONES}>{currentData.DESCRIPCION_RETENCION}</option>;
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    {this.state.id_items !== '0' &&
                                        <Factorprecio
                                            showUnit={true}
                                            listasPrecios={listasPrecios}
                                            item={this.state.id_items}
                                            precios={precios}
                                            aceptarCambios={this.aceptarCambios}
                                        ></Factorprecio>
                                    }
                                    <Button className="m-1" variant="primary" type="submit">{mensajeBoton}</Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </div>
                }
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => { this.setState({ mostrarMensaje: false }); this.initItem(this.state.id_items); }} ></Mensajes>
            </div>
        );
    }
}
export default (Formularioservicios);